import React from 'react';
import { Create } from 'react-admin';
import MetricForm from '../MetricForm';

function MetricCreate(props) {
  return (
    <Create {...props}>
      <MetricForm redirect="list" />
    </Create>
  );
}

export default MetricCreate;
